import PropTypes from "prop-types";

/* Numbered section wrapper used by the three request steps. */
const StepCard = ({ step, title, subtitle, id, children }) => (
  <section className="c4rtn__card c4rtn__step-card" aria-labelledby={id}>
    <header className="c4rtn__step-head">
      <span className="c4rtn__step-num" aria-hidden="true">
        {step}
      </span>
      <div>
        <h2 className="c4rtn__step-title" id={id}>
          <span className="c4rtn__step-kicker">Step {step}</span>
          {title}
        </h2>
        {subtitle ? <p className="c4rtn__step-sub">{subtitle}</p> : null}
      </div>
    </header>

    {children}
  </section>
);

StepCard.propTypes = {
  step: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default StepCard;
